export const LOCALIZATION_TEMPLATE_VALUE = "{VALUE}";
